import { constantURL } from "./ConstantURI"

const constantURI = () => {
    return constantURL + JSON.parse(localStorage.getItem("CompleteURI"));
}
export default constantURI



